import { render, staticRenderFns } from "./FileItems.vue?vue&type=template&id=212f4eaa&scoped=true"
import script from "./FileItems.vue?vue&type=script&lang=js"
export * from "./FileItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "212f4eaa",
  null
  
)

export default component.exports